import { createSelector } from 'reselect';

const authSelector = (state: any) => state.auth;

export const tokenSelector = createSelector(authSelector, (auth) => auth.currentUser.token);

export const currentUserSelector = createSelector(authSelector, (auth) => auth.currentUser);

export const authoritySelector = createSelector(authSelector, (auth) => auth.authority);

export const passwordExpiredWarnSelector = createSelector(authSelector, (auth) => auth.passwordExpired);
